import { useTranslation } from 'react-i18next';
import { PREVIEW_LANGUAGES } from '../../constants/languages';
import { Segmented } from './Segmented';

export interface LanguageTabsProps {
    /** Codes of the restaurant's supported languages. */
    languages: string[];
    value: string;
    onChange: (code: string) => void;
    /** Codes whose required fields are still empty; they get a dot. */
    incomplete?: string[];
}

/** One set of name/description fields at a time: pick the language here. Shows native names. */
export const LanguageTabs = ({ languages, value, onChange, incomplete = [] }: LanguageTabsProps) => {
    const { t } = useTranslation();
    return (
        <Segmented
            aria-label={t('ui.languageTabs')}
            value={value}
            onChange={onChange}
            options={languages.map((code) => ({
                value: code,
                label: PREVIEW_LANGUAGES.find((l) => l.code === code)?.originalLabel ?? code,
                lang: code,
                marked: incomplete.includes(code),
                markedLabel: t('ui.needsAttention'),
            }))}
        />
    );
};
